// Intent: the life-insurance upsell on goal details used to render ALWAYS,
// which annoyed the owner ("teraz trochę denerwuje"). New rule: it appears only
// once real money has piled up — at savings milestones — and each card can be
// closed for good. Thresholds are v1 heuristics grounded in PL saving habits
// (typical monthly saving 200–500 zł; 1000 zł ≈ "I have something worth
// protecting"); the exact first milestone is A/B-tested (25% vs 50%).

/** Goals below this target never show the upsell (a 1000 zł goal is not "wealth"). */
export const UPSELL_MIN_TARGET_GR = 500_000; // 5 000 zł
/** ...and neither does a big goal with pocket change on it. */
export const UPSELL_MIN_SAVED_GR = 100_000; // 1 000 zł

export const MILESTONES = [25, 50, 75] as const;
export type Milestone = (typeof MILESTONES)[number];

/**
 * Highest milestone reached and eligible for the upsell card, or null.
 * `firstMilestone` comes from the A/B variant (A=25, B=50): variant B users
 * simply never see the 25% card.
 */
export function milestoneFor(
  targetGr: number,
  savedGr: number,
  dismissed: number[],
  firstMilestone: Milestone = 25,
): Milestone | null {
  if (targetGr < UPSELL_MIN_TARGET_GR || savedGr < UPSELL_MIN_SAVED_GR) return null;
  const percent = (100 * savedGr) / targetGr;
  // Walk top-down so the user sees the freshest milestone they've crossed.
  for (let i = MILESTONES.length - 1; i >= 0; i--) {
    const m = MILESTONES[i];
    if (m < firstMilestone) break;
    if (percent >= m && !dismissed.includes(m)) return m;
  }
  return null;
}
